module.exports = __webpack_public_path__ + "static/media/progman_24.1380114b.ico";